import { render, staticRenderFns } from "./DefaultTpl.vue?vue&type=template&id=4c469ebe&"
import script from "./DefaultTpl.vue?vue&type=script&lang=js&"
export * from "./DefaultTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports